<template>
  <div id="tem">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'In Tem', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="bTem" class="soft-control">
        <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
          <form role="form" @submit.prevent="handleSubmit">
            <b-row class="sticky-top bg-light mx-0 pt-2" align-h="center">
              <b-col sm="12" md="12">
                <ValidationProvider name="Trọng lượng trên cuộn" rules="required" v-slot="{ errors }">
                  <base-input
                    label="Trọng lượng trên cuộn"
                    :error="errors[0]"
                    v-model="Tem.tlc"
                    :valid="errors.length == 0"
                  ></base-input>
                </ValidationProvider>
              </b-col>
              <b-col sm="12" md="4">
                <b-button class="mb-2" block variant="secondary" @click="doBack">
                  Trở về
                </b-button>
              </b-col>
              <b-col sm="12" md="4">
                <b-button block variant="info" @click="doSave">
                  <i class="fa fa-print" aria-hidden="true"></i> Lưu Tem
                </b-button>
              </b-col>
            </b-row>
          </form>
        </ValidationObserver>
        <div class="row p-1">
          <div class="col-md-12">
            <base-table :minHeight="$hMainContent + 420">
              <template slot="columns">
                <th>Loại tem</th>
                <th>Tem tiêu chuẩn</th>
                <th>Tem lẽ</th>
                <th>Tem Tùy chỉnh</th>
                <th>Số lượng</th>
              </template>
              <template slot="bodys">
                <tr>
                  <td>Tem bịt</td>
                  <td>
                    <b-row align-h="center">
                      <base-input readonly v-model="Tem.slbich" :mask="'number'" style="width:80px"></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input
                        :mask="'number'"
                        @change="temQuantityChange"
                        v-model="Tem.quantity"
                        style="width:80px"
                      ></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input
                        readonly
                        :value="Tem.slbich * Tem.quantity"
                        :mask="'number'"
                        style="width:80px"
                      ></base-input>
                    </b-row>
                    <TemBich :Tem="Tem" :manufacture="manufacture" style="width:300px; max-width: 300px;"></TemBich>
                    <b-row align-h="center">
                      <b-button @click="openManageTem('bich')" variant="primary" class="mt-2  mb-4">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td>
                    <b-row align-h="center">
                      <base-input
                        v-model="Tem.slbichOdd"
                        :mask="'number'"
                        @change="slbichOddChange"
                        style="width:80px"
                      ></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input :mask="'number'" readonly value="1" style="width:80px"></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input readonly :value="Tem.slbichOdd" :mask="'number'" style="width:80px"></base-input>
                    </b-row>
                    <TemBichOdd
                      :Tem="Tem"
                      :manufacture="manufacture"
                      style="width:350px; max-width: 350px;"
                    ></TemBichOdd>
                    <b-row align-h="center">
                      <b-button
                        @click="openManageTem('bich')"
                        variant="primary"
                        class="mt-2  mb-4
                        "
                      >
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td>
                    <b-row align-h="center">
                      <base-input
                        v-model="Tem.slbichcs"
                        @change="temQuantityChange"
                        :mask="'number'"
                        style="width:80px"
                      ></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input
                        :mask="'number'"
                        v-model="Tem.quantityCS"
                        @change="temQuantityChange"
                        style="width:80px"
                      ></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input
                        readonly
                        :value="Number(Tem.slbichcs) * Number(Tem.quantityCS)"
                        :mask="'number'"
                        style="width:80px"
                      ></base-input>
                    </b-row>
                    <TemBichCS
                      :Tem="Tem"
                      :isEdit="true"
                      :manufacture="manufacture"
                      style="width:350px; max-width: 350px;"
                    ></TemBichCS>
                    <b-row align-h="center">
                      <b-button
                        @click="openManageTem('bich')"
                        variant="primary"
                        class="mt-2  mb-4
                        "
                      >
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td class="text-right" style="width:150px">
                    <base-input v-model="totalQuantity" :mask="'number'"></base-input>
                  </td>
                </tr>
                <tr>
                  <td>Tem đơn hàng</td>
                  <td colspan="3">
                    <TemDH
                      :Tem="Tem"
                      :isEdit="true"
                      @change="temDHChange"
                      :manufacture="manufacture"
                      style="width:300px"
                    ></TemDH>
                    <b-row align-h="center">
                      <b-button @click="saveTemDH('dh')" variant="info" class="mt-2  mb-4">
                        <i class="fa fa-save" aria-hidden="true"></i>
                        Lưu Tem
                      </b-button>
                      <b-button @click="openManageTem('dh')" variant="primary" class="mt-2  mb-4">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td class="text-right" style="width:150px">
                    <base-input v-model="totalQuantity" :mask="'number'"></base-input>
                  </td>
                </tr>
                <tr>
                  <td>Tem bao</td>
                  <td class="pt-4">
                    <b-row align-h="center">
                      <base-input readonly v-model="Tem.slbao" :mask="'number'" style="width:80px"></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input :mask="'number'" v-model="Tem.quantitySack" style="width:80px"></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input
                        readonly
                        :value="Tem.slbao * Tem.quantitySack"
                        :mask="'number'"
                        style="width:80px"
                      ></base-input>
                    </b-row>
                    <TemBao :Tem="Tem" :manufacture="manufacture" style="width:350px; max-width: 350px;"></TemBao>
                    <b-row align-h="center">
                      <b-button @click="openManageTem('bao')" variant="primary" class="mt-2  mb-4">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td class="pt-4">
                    <b-row align-h="center">
                      <base-input v-model="Tem.slbaoo" :mask="'number'" style="width:80px"></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input :mask="'number'" readonly value="1" style="width:80px"></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input readonly :value="Tem.slbaoo" :mask="'number'" style="width:80px"></base-input>
                    </b-row>
                    <TemBaoOdd :Tem="Tem" :manufacture="manufacture" style="width:350px; max-width: 350px;"></TemBaoOdd>
                    <b-row align-h="center">
                      <b-button @click="openManageTem('bao')" variant="primary" class="mt-2  mb-4">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td class="pt-4">
                    <b-row align-h="center">
                      <base-input v-model="Tem.slbaocs" :mask="'number'" style="width:80px"></base-input>
                      <h4 class="mt-1 mx-2">X</h4>
                      <base-input :mask="'number'" v-model="Tem.quantitySackCS" style="width:80px"></base-input>
                      <h3 class="mx-2">=</h3>
                      <base-input
                        readonly
                        :value="Number(Tem.slbaocs) * Number(Tem.quantitySackCS)"
                        :mask="'number'"
                        style="width:80px"
                      ></base-input>
                    </b-row>
                    <TemBaoCS
                      :Tem="Tem"
                      :isOdd="true"
                      :isEdit="true"
                      :manufacture="manufacture"
                      style="width:350px; max-width: 350px;"
                    ></TemBaoCS>
                    <b-row align-h="center">
                      <b-button @click="openManageTem('bao')" variant="primary" class="mt-2  mb-4">
                        <i class="fa fa-print" aria-hidden="true"></i>
                        Quản lý Tem
                      </b-button>
                    </b-row>
                  </td>
                  <td class="text-right">
                    <h4>
                      {{ $formatNumber(Tem.slbaoo + Tem.slbao * Tem.quantitySack) }}
                    </h4>
                  </td>
                </tr>
              </template>
            </base-table>
          </div>
        </div>
      </block>
      <PreviewTem ref="preview"></PreviewTem>
    </div>
  </div>
</template>
<script>
import TemBich from './__TemBich';
import TemBichOdd from './__TemBichOdd';
import TemBichCS from './__TemBichCS';
import TemBao from './__TemBao';
import TemBaoOdd from './__TemBaoOdd';
import TemBaoCS from './__TemBaoCS';
import TemDH from './__TemDH';

import PreviewTem from './__PreviewTem';

import { manufactureService, temService } from '@/_services';
export default {
  name: 'tem-add',
  components: {
    TemBich,
    TemBichCS,
    TemBichOdd,
    TemBao,
    TemBaoCS,
    TemBaoOdd,
    TemDH,
    PreviewTem
  },
  data() {
    return {
      manufacture: {},
      Tem: {
        slbich: 0, // số lương 1 bịch = dvt/bịch
        slbichcs: 0, // số lương 1 bịch = dvt/bịch tùy chỉnh

        slbichOdd: 0, // số lượng bịch lẽ
        slcbich: 0, // số lượng cuộn / bịch = Cuộn/bịch
        slbaocs: 0,
        tlc: 0, // trọng lượng cuộn
        tlbich: 0, // trọng lượng bịch
        tlbao: 0, // trọng lượng bao
        tlbaoOdd: 0, // trọng lượng bao lẽ
        tlbaogopOdd: 0, // Gộp lẽ
        slcbao: 0, // số lượng cuộn / bao
        slbao: 0, // số lượng 1 bao  = dvt/bao
        slbaoo: 0, // số lượng bao lẽ
        slc: 0, // số lượng / cuộn = dvt/cuộn
        slco: 0, // số lượng / cuộn = dvt/cuộn
        quantity: 0, // số lượng tem bịch
        quantityCS: 0, // số lượng tem bịch Tùy chỉnh
        slcbichOdd: 0,
        quantitySack: 1, // số lượng tem bao
        quantitySackCS: 0,
        quantityCore: 1, // số lượng tem lẽ
        manufature: {},
        gMet: 0,
        mKg: 0,
        hesobao: 1,
        hesobaoOdd: 1,
        hesobich: 1,
        hesobichOdd: 1,
        tlbichgop: 0,
        unit: ''
      },
      totalQuantity: 0
    };
  },
  mounted() {
    var self = this;
    if (this.$route.query.manufacture) {
      temService.getTemFromManufacture(this.$route.query.manufacture).then(res => {
        debugger;
        if (res.data) {
          self.manufacture = res.data.manufature;
          self.totalQuantity = res.data.quantity * res.data.slbich + res.data.slbichOdd;
          self.Tem = res.data;
          self.Tem.unitSackCS = self.Tem.unitSackCS == '' ? self.manufacture.unit : self.Tem.unitSackCS;
          self.Tem.unitCS = self.Tem.unitCS == '' ? self.manufacture.unit : self.Tem.unitCS;
        } else {
          manufactureService.findOne(this.$route.query.manufacture).then(res => {
            let manufacture = res.data;
            this.manufacture = manufacture;
            if (manufacture && manufacture.id) {
              this.totalQuantity = this.manufacture.quantityOrder;
              this.calcSL();
              this.Tem.slbaoo = this.totalQuantity - this.Tem.slbao * this.Tem.quantitySack;
              this.Tem.unit = manufacture.unit;
              this.Tem.unitSackCS = manufacture.unit;
              this.Tem.unitCS = manufacture.unit;
            } else {
              this.$alertify.warning('Chưa tạo tem này', {
                duration: 4000
              });
            }
          });
        }
      });
    }
  },
  methods: {
    fetchData() {},
    calcSL() {
      this.Tem.manufature = {
        id: this.manufacture.id
      };

      this.Tem.slbich = this.manufacture.productSpecify.unitBag;
      this.Tem.quantity = Math.floor(this.totalQuantity / this.Tem.slbich);
      this.Tem.slbichOdd = this.totalQuantity - this.Tem.slbich * this.Tem.quantity;
      this.Tem.slcbich = this.manufacture.productSpecify.hankBag;
      this.Tem.slcbao = this.manufacture.productSpecify.hankSack;
      this.Tem.slc = this.manufacture.productSpecify.unitHank;
      this.Tem.slco = 0;

      this.Tem.tlbich = Number(this.Tem.gMet) * Number(this.Tem.slbich);
      this.Tem.tlbichOdd = Number(this.Tem.gMet) * Number(this.Tem.slbichOdd);
      // this.Tem.tlbichgop = Number(this.Tem.slcbich) * Number(this.Tem.hesobich) + Number(this.Tem.tlbich );
      // this.Tem.tlbich = Number(this.Tem.tlc) * Number(this.Tem.slcbich);

      this.Tem.tlbao = Number(this.Tem.gMet) * Number(this.Tem.slbao);
      this.Tem.tlbaoOdd = Number(this.Tem.gMet) * Number(this.Tem.slbaoo);
      //  this.Tem.tlbaogop = Number(this.Tem.slcbao) * Number(this.Tem.hesobao) + Number(this.Tem.tlbao );

      if (this.Tem.slc && this.Tem.slc != 0) {
        if (!this.Tem.slcbichOdd || this.Tem.slcbichOdd == 0)
          this.Tem.slcbichOdd = Math.ceil(this.Tem.slbichOdd / this.Tem.slc);
        if (!this.Tem.slcbaoOdd || this.Tem.slcbaoOdd == 0)
          this.Tem.slcbaoOdd = Math.ceil(this.Tem.slbaoo / this.Tem.slc);
      }

      this.Tem.slbao = this.manufacture.productSpecify.unitSack;
      this.Tem.quantitySack = 0;
      if (this.Tem.slbao != 0) this.Tem.quantitySack = Math.floor(this.totalQuantity / this.Tem.slbao);
    },
    temDHChange() {
      this.calcSL();
      this.Tem.slbaoo = this.totalQuantity - this.Tem.slbao * this.Tem.quantitySack;
    },
    doSave() {
      this.$refs.bTem.block();
      let Tem = Object.assign({}, this.Tem);
      delete Tem.temDetail;
      delete Tem.temDetails;
      temService
        .create(Tem)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.Tem = res.data;
        })
        .finally(() => {
          this.$refs.bTem.unBlock();
        });
    },
    saveTemDH() {
      this.$refs.bTem.block();
      let Tem = Object.assign({}, this.Tem);
      Tem.manufature = {
        id: Tem.manufature.id
      };
      Tem.temDetail = [];
      Tem.temDetails = [];
      temService
        .createTemOrder(Tem)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.Tem = res.data;
        })
        .finally(() => {
          this.$refs.bTem.unBlock();
        });
    },
    doBack() {
      this.$router.go(-1);
    },
    openManageTem(type) {
      this.$router.push({
        name: 'tem-manage',
        query: {
          tem: this.Tem.id,
          type: type
        }
      });
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    doPrintTemBich() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, 'bich');
    },
    doPrintTemBao() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, 'bao');
    },
    doPrintTemLoi() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, 'loi');
    },
    temQuantityChange() {
      this.totalQuantity = this.Tem.quantity * this.Tem.slbich + this.Tem.slbichOdd;
    },
    slbichOddChange() {
      this.totalQuantity = this.Tem.quantity * this.Tem.slbich + this.Tem.slbichOdd;
      this.calcSL();
      this.Tem.slbaoo = this.totalQuantity - this.Tem.slbao * this.Tem.quantitySack;
    }
  },
  watch: {
    'Tem.tlc': function() {
      console.log('tinh toan');
      this.calcSL();
      this.Tem.slbaoo = this.totalQuantity - this.Tem.slbao * this.Tem.quantitySack;
    },
    'Tem.slbaoo': function() {
      console.log('tinh toan');
      this.calcSL();
    },
    totalQuantity: function() {
      this.calcSL();
      this.Tem.slbaoo = this.totalQuantity - this.Tem.slbao * this.Tem.quantitySack;
    }
  }
};
</script>
<style lang="scss">
#tem {
  .soft-control .table-soft tbody tr:hover {
    background: unset;
  }
}
</style>
